import React from "react";
import {
  BrowserRouter as Router,
  Routes as BaseRoutes,
  Route,
  Navigate,
} from "react-router-dom";
import { observer } from "mobx-react-lite";
import { PageRoutes, ProfileRoutes, useViewModel } from "@utils";
import {
  LoginPage,
  CalendarPage,
  ProfilePage,
  LoginViewModel,
  MeetingPlanerPage,
  EmailConfirmationPage,
  FilteredMeetingsPage,
} from "@views";
import {
  MyCalendarsTab,
  ProfileDetailsTab,
  NotificationSettingsTab,
} from "@components";
import { Header } from "../header";
import { isMobile } from "react-device-detect";
import { OnboardingPage } from "../../views/onboardingPage";
import { MeetingConfirmationPage } from "../../views/confirmationPages";
import { PushPage } from "../../views/pushPage/PushPage";
import { EmployeesPage } from "../../views/employeesPage/EmployeesPage";

const Routes = () => {
  const loginViewModel = useViewModel(LoginViewModel);

  return (
    <Router>
      {loginViewModel.authorized ? (
        <>
          <Header />
          <BaseRoutes>
            <Route path={PageRoutes.CALENDAR_PAGE} element={<CalendarPage />} />
            <Route path={PageRoutes.PROFILE_PAGE} element={<ProfilePage />}>
              <Route path="" element={<ProfileDetailsTab />} />
              <Route
                path={ProfileRoutes.CONNECTED_CALENDARS_TAB}
                element={<MyCalendarsTab />}
              />
              <Route
                path={ProfileRoutes.NOTIFICATIONS_TAB}
                element={<NotificationSettingsTab />}
              />
            </Route>
            <Route
              path={PageRoutes.MEETING_PLANNER_PAGE}
              element={<MeetingPlanerPage />}
            />
            <Route
              path={PageRoutes.FILTERED_MEETINGS_PAGE}
              element={<FilteredMeetingsPage />}
            />
            <Route
              path="*"
              element={
                loginViewModel.firstAuthorization ? (
                  <Navigate to={PageRoutes.ONBOARDING} />
                ) : (
                  <Navigate to={PageRoutes.CALENDAR_PAGE} />
                )
              }
            />
            <Route
              path={PageRoutes.EMAIL_CONFIRMATION}
              element={<EmailConfirmationPage />}
            />
            <Route
              path={PageRoutes.MEETING_CONFIRMATION}
              element={<MeetingConfirmationPage />}
            />
            <Route path={PageRoutes.ONBOARDING} element={<OnboardingPage />} />
            {isMobile && (
              <>
                <Route path={PageRoutes.PUSH_PAGE} element={<PushPage />} />
                <Route
                  path={PageRoutes.EMPLOYEES_PAGE}
                  element={<EmployeesPage />}
                />
              </>
            )}
          </BaseRoutes>
        </>
      ) : (
        <BaseRoutes>
          <Route path={PageRoutes.LOGIN} element={<LoginPage />} />
          <Route path="*" element={<Navigate to={PageRoutes.LOGIN} />} />
          <Route
            path={PageRoutes.EMAIL_CONFIRMATION}
            element={<EmailConfirmationPage />}
          />
          <Route
            path={PageRoutes.MEETING_CONFIRMATION}
            element={<MeetingConfirmationPage />}
          />
          {/* <Route path={PageRoutes.OUTER_MEETING_CONFIRMATION} element={<MeetingConfirmationPage isOuter/>} /> */}
        </BaseRoutes>
      )}
    </Router>
  );
};

export default observer(Routes);
